import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Activate() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const navigate = useNavigate();
  const [tokenInput, setTokenInput] = useState(token);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!tokenInput) return toast.error("Activation token required");
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/activate", { token: tokenInput, password });
      toast.success("Account activated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Activation failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <Card className="w-full max-w-md p-8 border-slate-200">
        <h2 className="text-2xl font-semibold tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>Activate your account</h2>
        <p className="text-sm text-slate-500 mt-1">Set a password to complete activation.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label>Activation Token</Label>
            <Input data-testid="activate-token-input" value={tokenInput} onChange={(e) => setTokenInput(e.target.value)} className="mt-1.5 font-mono text-xs" />
          </div>
          <div>
            <Label>New Password</Label>
            <PasswordInput data-testid="activate-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
          </div>
          <div>
            <Label>Confirm Password</Label>
            <PasswordInput data-testid="activate-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" />
          </div>
          <Button data-testid="activate-submit-button" disabled={loading} className="w-full btn-brand">
            {loading ? "Activating…" : "Activate Account"}
          </Button>
          <div className="text-center text-sm">
            <Link to="/login" className="text-[#fd7e14] hover:underline">Back to login</Link>
          </div>
        </form>
      </Card>
    </div>
  );
}
